/**
 * Helper para cortar uma imagem usando os pixels devolvidos pelo react-easy-crop.
 * Saída: data URL JPEG quality 0.85, max 512×512 pra manter localStorage leve.
 */

export type Area = {
  x: number;
  y: number;
  width: number;
  height: number;
};

function loadImage(dataUrl: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err);
    img.src = dataUrl;
  });
}

export async function cropImageToDataUrl(
  imageSrc: string,
  pixelCrop: Area,
  maxSize = 512,
  quality = 0.85,
): Promise<string> {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Não foi possível obter o contexto 2D do canvas');

  const targetSize = Math.min(maxSize, Math.min(pixelCrop.width, pixelCrop.height));
  canvas.width = targetSize;
  canvas.height = targetSize;

  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    targetSize,
    targetSize,
  );

  return canvas.toDataURL('image/jpeg', quality);
}
